import { GetServerSideProps, NextPage } from "next";
import { Charts, ChartArt } from "../../chart.constants";
import { ChartRelease, ChartDropdownItem, ChartUnavailableReason } from "../../chart.models";
import { getChartReleaseAndDates, chartPageCacheControl } from "../../services/server/page-data.service";
import ChartPage from "../../components/chart-page.component";
import { handleRouterQueries } from "../../services/client/url.service";
import { useRouter } from "next/router";
import { useEffect } from "react";

type PageProps = {
	chartRelease?: ChartRelease
	allChartReleaseDates: Array<ChartDropdownItem>
	unavailableReason?: ChartUnavailableReason
}

const CHART = Charts.TopThumbHundred;

const TopThumbHundredChart: NextPage<PageProps> = ({chartRelease, allChartReleaseDates, unavailableReason}) => {
	const router = useRouter();
	useEffect(() => {
		let isComponentMounted = true;
		if (chartRelease && isComponentMounted) {
			const query = router.query;
			handleRouterQueries(CHART.path, chartRelease, query);
		}
		return () => { isComponentMounted = false; };
	}, [chartRelease]);

	return <ChartPage
		chartRelease={chartRelease}
		name={CHART.name}
		metaTitle="Pandora's Top Thumb Hundred Chart"
		description={"The Pandora Top Thumb Hundred Chart shows which releases in the last 30 days get the most thumbs up."}
		art={ChartArt.TopThumbHundred}
		chartID={CHART.id}
		weekOfText={"Weekend of "}
		allChartReleases={allChartReleaseDates}
		unavailableReason={unavailableReason}
	/>;
};

export const getServerSideProps: GetServerSideProps<PageProps> = async ({res, ...context}) => {
	// getChartReleaseAndDates absorbs charts API failures, so this never throws and the
	// page never 500s - but the cache header depends on what came back, so it is set after.
	const props: PageProps = await getChartReleaseAndDates(context, CHART.id);

	res.setHeader("Cache-Control", chartPageCacheControl(props));

	return { props };
};

export default TopThumbHundredChart;